import React, { useState } from "react";

interface SessionExpiredMessageProps {
  isDarkMode: boolean;
}

export const SessionExpiredMessage: React.FC<SessionExpiredMessageProps> = ({
  isDarkMode,
}) => {
  const [showCloseButton, setShowCloseButton] = useState(true);
  const [closeAttempted, setCloseAttempted] = useState(false);

  const handleCloseClick = () => {
    setCloseAttempted(true);
    try {
      window.close();
      // If we reach this point and window is still open after a short delay,
      // the close didn't work
      setTimeout(() => {
        if (!window.closed) {
          setShowCloseButton(false);
        }
      }, 100);
    } catch {
      // If close throws an error, hide the button
      setShowCloseButton(false);
    }
  };
  const containerStyle: React.CSSProperties = {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: isDarkMode
      ? "rgba(26, 26, 26, 0.5)"
      : "rgba(249, 250, 251, 0.5)",
    backdropFilter: "blur(2px)",
    position: "fixed",
    top: 0,
    left: 0,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    padding: "20px",
    zIndex: 1000,
  };

  const cardStyle: React.CSSProperties = {
    backgroundColor: isDarkMode
      ? "rgba(45, 45, 45, 0.98)"
      : "rgba(255, 255, 255, 0.98)",
    borderRadius: "12px",
    padding: "40px",
    maxWidth: "500px",
    width: "100%",
    textAlign: "center",
    boxShadow: isDarkMode
      ? "0 8px 32px rgba(0, 0, 0, 0.5)"
      : "0 8px 32px rgba(0, 0, 0, 0.15)",
    border: isDarkMode
      ? "1px solid rgba(255, 255, 255, 0.1)"
      : "1px solid rgba(0, 0, 0, 0.1)",
  };

  const iconStyle: React.CSSProperties = {
    fontSize: "64px",
    marginBottom: "20px",
    opacity: 0.6,
  };

  const titleStyle: React.CSSProperties = {
    fontSize: "24px",
    fontWeight: 600,
    color: isDarkMode ? "#ffffff" : "#111827",
    marginBottom: "16px",
    letterSpacing: "-0.025em",
  };

  const descriptionStyle: React.CSSProperties = {
    fontSize: "16px",
    color: isDarkMode ? "#94a3b8" : "#6b7280",
    lineHeight: 1.6,
    marginBottom: "32px",
  };

  const buttonStyle: React.CSSProperties = {
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: 500,
    backgroundColor: isDarkMode ? "#374151" : "#f3f4f6",
    color: isDarkMode ? "#d1d5db" : "#374151",
    border: "1px solid",
    borderColor: isDarkMode ? "#6b7280" : "#d1d5db",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={iconStyle}>💤</div>
        <h1 style={titleStyle}>Session beendet</h1>
        <p style={descriptionStyle}>
          Deine Terminal-Session wurde beendet. Das kann verschiedene Gründe
          haben, z.B. weil die Session von dir oder dem Server beendet wurde,
          durch Inaktivität, Wartungsarbeiten oder eine technische Störung.
        </p>
        <p style={descriptionStyle}>
          Du kannst über das mStudio eine neue Session starten.
        </p>
        {showCloseButton ? (
          <button
            onClick={handleCloseClick}
            style={buttonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = isDarkMode
                ? "#4b5563"
                : "#e5e7eb";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = isDarkMode
                ? "#374151"
                : "#f3f4f6";
            }}
          >
            Fenster schließen
          </button>
        ) : closeAttempted ? (
          <p
            style={{
              ...descriptionStyle,
              fontSize: "12px",
              fontStyle: "italic",
              marginBottom: "0",
              color: isDarkMode ? "#9ca3af" : "#6b7280",
            }}
          >
            Bitte schließe das Fenster manuell (Strg+W oder Browser-Button).
          </p>
        ) : null}
      </div>
    </div>
  );
};
